import React, { useState, useRef, useEffect, useMemo } from 'react';
import useApiStatusDispatch from '../../hooks/useApiStatusDispatch';
import { useDispatch, useSelector } from "react-redux";
import JoditEditor from "jodit-react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import classes from "./Blog.module.css"
import { Form } from 'react-bootstrap';
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row"
import { createEditPost } from "../../state/blogSlice"
import { getAllPosts, selectAllPosts } from "../../state/blogSlice";
import Spinner from "react-bootstrap/Spinner"
import CenteredLoader from '../CenteredLoader/CenteredLoader';
import styles from './Blog.module.css'
import './styles.css'
import DOMPurify from 'dompurify';


function BlogAddEdit({ showAddEditModal, setShowAddEditModal, postData, editPostLoading, type }) {
    const editor = useRef(null)
    const [title, setTitle] = useState("");
    const [oldTitle, setOldTitle] = useState("");
    const [titleError, setTitleError] = useState(false)
    const [isPublic, setIsPublic] = useState("0")
    const [isSaving, setIsSaving] = useState(false);
    const [newTitle, setNewTitle] = useState("title");
    const [newBody, setNewBody] = useState("body");
    const [postId, setPostId] = useState("");
    const [body, setBody] = useState('')
    const [isActive, setIsActive] = useState("0");


    

    useEffect(() => {
        if (postData.title?.length > 1) {
            setBody(DOMPurify.sanitize(postData.body))
            setIsActive(postData.is_active ? postData.is_active : "0")
            setTitle(postData.title);
            setIsPublic(postData.is_public);
            setPostId(postData.post_id)
        }
    }, [postData])

    const dispatch = useDispatch()
    const statusDispatch = useApiStatusDispatch();
    
    let buttonOptions =  [
        "bold","italic","underline","strikethrough","eraser","superscript","subscript","ul","ol",
        "indent","outdent","left","font","fontsize","paragraph","classSpan", "link", "brush","image"]

    const config = useMemo(() => ({
       buttons: buttonOptions,
       buttonsSM: buttonOptions,
       ButtonsMD: buttonOptions,
       buttonsXS: buttonOptions,
            /*{
                tooltip: 'Enter text and insert',
                icon: 'link',
                popup: (editor, current, self, close) => {
                    let selection = editor.selection.save()
                    console.log(selection);
                    const form = editor.create.fromHTML(
                        `<Modal>
                            <form>
                              <div> URL </div>
                              <input id="url" type="text"/> 
                              <div> Text </div>
                              <input id="urlLabel" type="text"/> 
                              <div> </div>
                              <button  type="submit">Insert</button>
                            </form>
                            </Modal>`
                    );
                    editor.e.on(form, 'submit', (e) => {
                        e.preventDefault();
                        let url = document.querySelector('#url').value;
                        if (url.slice(0, 4) !== "http") {
                            url = "http://" + url;
                        }
                        editor.selection.restore(selection)
                        editor.s.insertHTML(`<a href="${url}">` + document.querySelector('#urlLabel').value + "</a>");
                        close();
                    });
                    return form;
                }
            }*/
        
        readonly: false, // all options from https://xdsoft.net/jodit/doc/
        "minHeight": 400,
        uploader: {
            url: `${window.location.protocol}//${window.location.hostname}/api/posts/api/`,
            prepareData: function (formdata) {
                let file = formdata.getAll("files[0]")[0];
                console.log(file, "file")
                formdata.append("image", file)
                formdata.append('action', 'uploadImageToS3')
                return formdata;
            },
            isSuccess: function (resp) {
                return !resp.error;
            },
            getMsg: function (resp) {
                return resp.msg.join !== undefined ? resp.msg.join(' ') : resp.msg;
            },
            process: function (res) {
                //this.events.fire('errorPopap', ['Files ' + images.join(',') + ' were uploaded', 'success']);
                const data = {
                    files: res.images,
                    path: '',
                    baseurl: '',
                    error: res.error,
                    msg: res.msg
                };
                console.log(data)
                return data
            },
            defaultHandlerSuccess: function (data, resp) {
                console.log(data, resp)
                if (data.files && data.files.length) {
                    for (let i = 0; i < data.files.length; i += 1) {
                        this.selection.insertImage(data.files[i]);
                    }
                }
            },
        }
    }),[])

    function handleSave(updatedIsActive) {
        if (!title) {
            setTitleError("title required")
            return;
        }
        let update_publish_date = "0";
        if (updatedIsActive === "1" && isActive === "0") {
            update_publish_date = "1"
        }

        let payload
        if (type === "edit") {
            payload = {
                title,
                body,
                is_active: updatedIsActive,
                update_publish_date: update_publish_date,
                is_public: isPublic,
                old_title: oldTitle,
                action: "createEditPost",
                type: "edit",
                post_id: postId,
            }
        } else {
            payload = {
                title,
                body,
                is_active: updatedIsActive,
                is_public: isPublic,
                update_publish_date: update_publish_date,
                action: "createEditPost",
                type: "create",
            }
        }

        statusDispatch(createEditPost(payload), "blog", type === "edit" ? "update" : "create")
            .then(res => {
                if (res.payload.success === "1") {
                    setShowAddEditModal(false)
                    clearModal();
                    dispatch(getAllPosts())
                } else {
                    if (res.payload.duplicate_title === "1") {
                        setTitleError("Title already in use. Please enter a different one.")
                    } else {
                        alert("Error adding record. Please retry or contact support@fitsw.com for support.")
                    }
                }
            })

    }

    function clearModal() {
        setTitle("");
        setTitleError("");
        setIsActive("");
        setIsPublic("1");
        setOldTitle("");
        setBody("")
    }

    function handleClose() {
        if (window.confirm("Are you sure you want to discard any changes?")) {
            setShowAddEditModal(false)
            clearModal();
        }
    }





    return (
        <>
            <div show={showAddEditModal}
                dialogClassName={classes.blogAddEdit}
                onHide={body ? handleClose : clearModal}
            >
                {editPostLoading ? <div className='m-5'> <CenteredLoader /></div> :
                    <div >
                        <Form.Group className="mb-3" controlId="title">
                            <Form.Label><b>Title</b> </Form.Label>
                            <Form.Control type="text" value={title} onChange={(e) => {
                                setTitle(e.target.value)
                                setTitleError("");
                            }} placeholder="title" />
                            <p className="text-danger mt-1"> {titleError}</p>
                        </Form.Group>

                        <JoditEditor
                            ref={editor}
                            value={body}
                            config={config}
                            tabIndex={1} // tabIndex of textarea
                            className={styles.jodit}
                            // key={1}
                            onBlur={newBody => setBody(DOMPurify.sanitize(newBody))} // preferred to use only this option to update the Body for performance reasons
                            onChange={newContent=>console.log(newContent)}
                        />

                        <Form.Group>
                            <div className="mb-1 mt-3 ">
                                    <Form.Label> <b> Viewable By </b> </Form.Label>
                            </div>
                            <div className="">
                                <div >
                                    <Form.Check
                                        name="is_public"
                                        label={'Everyone'}
                                        value="1"
                                        type="radio"
                                        checked={isPublic === "1"}
                                        onChange={(e) => {
                                            setIsPublic(e.target.value)
                                        }}
                                    />
                                    <Form.Check
                                        name="is_public"
                                        label={'Client Only'}
                                        value="0"
                                        type="radio"
                                        checked={isPublic === "0"}
                                        onChange={(e) => {
                                            setIsPublic(e.target.value)
                                        }}
                                    />
                                </div>
                            </div>
                        </Form.Group>

                        <div className="d-md-flex justify-content-center" style={{
                            paddingBottom:'200px'
                        }}>
                            <Button variant={"danger"} className="m-1" onClick={() => handleClose()}> Discard Changes </Button>
                            <Button variant={"primary"} className="m-1 "
                                onClick={() => {
                                    let updatedIsActive = "0";
                                    handleSave(updatedIsActive)
                                }}>
                                {isSaving ? <div style={{
                                    width: '100%',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}>
                                    <div className="d-flex align-items-center flex-column text-white p-1">
                                        <Spinner size="sm" animation="border" role="status" >
                                            <span className="sr-only">Loading...</span>
                                        </Spinner>
                                    </div>
                                </div>
                                    : "Save As Draft"}
                            </Button>
                            <Button variant={"success"} className="m-1 "
                                onClick={() => {
                                    let updatedIsActive = "1";
                                    handleSave(updatedIsActive)
                                }}>
                                {isSaving ? <div style={{
                                    width: '100%',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}>
                                    <div className="d-flex align-items-center flex-column text-white p-1">
                                        <Spinner size="sm" animation="border" role="status" >
                                            <span className="sr-only">Loading...</span>
                                        </Spinner>
                                    </div>
                                </div>
                                    : "Publish Blog"} </Button>
                        </div>
                    </div>
                }
            </div >
        </>


    );

}

export default BlogAddEdit